<template>
  <div
    :class="[
      $style.tabGroup,
      {
        [$style.typeGhost]: type === 'ghost',
        [$style.alignItemsStretch]: alignItemsStretch,
        [$style.noBorder]: noBorder,
      },
    ]"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
import type { IconName } from "./icons/iconNames.generated";
import type { TabType } from "./types";

withDefaults(
  defineProps<{
    icon?: IconName;
    selected?: boolean;
    alignItemsStretch?: boolean;
    type?: TabType;
    noBorder?: boolean;
  }>(),
  {
    icon: undefined,
    selected: false,
    alignItemsStretch: false,
    type: "default",
    noBorder: false,
  },
);
</script>

<style module lang="scss">
@use "../styles/generated/figma_typo_mixins.scss" as FigmaTypoMixins;

.tabGroup {
  display: flex;
  min-width: 0;
  align-items: center;
  text-align: center;
  border-bottom: var(--sca-tab-group-border-bottom, 1px) solid var(--color-border-default);

  &.noBorder {
    border-bottom: unset;
  }

  &.alignItemsStretch {
    align-items: stretch;
    justify-content: space-between;
    > * {
      flex: 1;
    }
  }

  &.typeGhost {
    gap: var(--space-component-gap-small);
    border-bottom: none;
  }
}
</style>
